import React, { useState, useEffect, useCallback, useContext } from "react";
import styled from "styled-components";
import CustomButton from "./CustomButton";
import toast from "react-hot-toast";
import moment from "moment-timezone";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import { UserContext } from "../../Context/user_context";
import PageLoader from "./PageLoader";

function CustomOTP({ Title, Active, Type, otpValue, onOtpChange, otpExpiry }) {
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [startTimer, setStartTimer] = useState(false);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const maskEmail = (email) => {
    const [localPart, domain] = email.split("@");
    const [domainName, domainExt] = domain.split(".");

    const maskedLocal =
      localPart.length > 2
        ? localPart[0] + "*".repeat(localPart.length - 2) + localPart.slice(-1)
        : localPart;

    const maskedDomain =
      domainName.length > 2
        ? domainName[0] +
          "*".repeat(domainName.length - 2) +
          domainName.slice(-1)
        : domainName;

    return `${maskedLocal}@${maskedDomain}.com`;
  };

  const handleOTPClick = useCallback(() => {
    setIsLoading(true);
    getApiClient()
      .sendOTP()
      .then((res) => {
        if (res.status === 200) {
          setCurrentTime(120);
          setStartTimer(true);
          toast.success(
            "A SECURITY CODE has been sent to your email " + maskEmail(user.emailaddress1)
          );
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    let timerInterval;

    const expiryTime = moment.tz(otpExpiry, "America/Los_Angeles");
    const now = moment().tz("America/Los_Angeles");
    
    if (expiryTime.isAfter(now)) {
      const diffInSeconds = expiryTime.diff(now, "seconds");
      setStartTimer(true);
      setCurrentTime(diffInSeconds);
    } else {
      setCurrentTime(120);
    }

    timerInterval = setInterval(() => {
      setCurrentTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerInterval);
          setStartTimer(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [startTimer, otpExpiry]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Container>
        <FieldName>{Title}</FieldName>
        {Active ? (
          <Flex>
            <CustomField
              value={otpValue}
              type={Type ? Type : "text"}
              onChange={(e) => onOtpChange(e.target.value)}
            />
            <ButtonWrapper>
              <CustomButton
                borderRadius="0px 5px 5px 0px"
                handle={handleOTPClick}
                disabled={startTimer}
                height="36px"
                width="140px"
                background={startTimer ? "#D8D8D8" : ""}
                color={startTimer ? "black" : ""}
                title={
                  startTimer && currentTime > 0
                    ? formatTime(currentTime)
                    : "Request code"
                }
              />
            </ButtonWrapper>
          </Flex>
        ) : (
          <Text>{otpValue ? otpValue : "Empty"}</Text>
        )}
      </Container>
    </>
  );
}


const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;

const FieldName = styled.div`
  text-align: right;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;
const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;

const CustomField = styled.input`
  outline: none;
  border: none;
  padding-left: 10px;
  border-radius: 5px 0px 0px 5px;
  background-color: var(--editable);
  height: 36px;
  min-width: 80px;
  width: 100%;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Timer = styled.span`
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  color: #304961;
`;

export default CustomOTP;